<template>
    <modal class="modal-wrapper" v-if="isOpen" @hide-modal="hideModal()" :width="width" :height="height">
        <template v-slot:content>
            <div class="inquire-wrapper">
                <h3 class="text-center bold" id="modal-title">{{ confirmation ? 'Thank you!' : `Inquire about ${activeProductInfo ? activeProductInfo.name: productName}` }}</h3>
                <hr />
                <div v-if="confirmation" class="confirmation">
                    <p>We've received your message. A dedicated sales team member will get back to you within 24 hours.</p>
                    <p>If you have any further questions, feel free to reach out to {{ ownerEmail }}.</p>
                </div>
                <div v-else class="inputs-wrapper">
                    <div v-if="isVGBasicCustomer" class="input-wrapper">
                        Your business does not currently leverage the full Vehicle Gateway functionality. Please contact your sales rep to upgrade or add-on to your fleet.
                    </div>
                    <div class="input-wrapper">
                        <label for="message">Your message <span class="text-red-700">&#42;</span></label>
                        <textarea @change="keyUpHandler($event, 'message')" name="message" type="text" :value="message"/>
                    </div>
                    <div class="input-wrapper">
                        <label for="fullName">Full name (First and Last name)<span class="text-red-700">&#42;</span></label>
                        <input @change="keyUpHandler($event, 'fullName')" type="text" name="fullName" :value="fullName"/>
                    </div>
                    <div class="input-wrapper">
                        <label for="email">Email <span class="text-red-700">&#42;</span></label>
                        <input @change="keyUpHandler($event, 'email')" type="text" name="email" :value="email"/>
                    </div>
                </div>
                <p class="text-xl text-red-700 text-center" v-if="error !== ''">{{ error }}</p>
                <v-button
                    position="center"
                    mobile="11"
                    tablet="9"
                    desktop="9"
                    styling="primary rounded-full text-base"
                    textAlign="center"
                    :disabled="false"
                    @onClickEvent="confirmation ? hideModal() : productInquiryRequestHandler()"
                    >
                    <template v-slot:content>
                        <span>
                            {{ confirmation ? 'Close' : 'Submit' }}
                        </span>
                    </template>
                </v-button>
            </div>
        </template>
    </modal>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex';
    import Modal from '../../utils/modal';
    import vButton from '../../utils/button';
    import ErrorStateIcon from '../../utils/error-state-icon';
    import DOMPurify from 'dompurify';
    import { analyticsTrack } from "../../../../bundled_js/analytics_wrapper";
    import Resize from '../webstore/mixins/resizeMixin';
    import Notice from '../../utils/notice';

    export default {

        components: {Modal, vButton, ErrorStateIcon, Notice},

        mixins: [Resize],

        props: {
            isOpen: {
                type: Boolean,
                required: true
            },
            productName: {
                type: String,
                required: false,
                default: ""
            },
            productKey:  {
                type: String,
                required: false,
                default: ""
            },
            homePage: {
                type: Boolean,
                required: false,
                default: false
            }
        },
        inject: {
            ownerEmail: {
                default: ""
            }
        },
        data() {
            return {
                windowWidth: window.innerWidth,
                email: '',
                message: '',
                fullName: '',
                error: '',
                confirmation: false,
            }
        },

        computed: {
            ...mapGetters([
                'activeProductInfo',
                'isVGBasicCustomer'
            ]),

            ...mapGetters('content', [
                'webstoreContent'
            ]),

            width() {
                return this.windowWidth > 550 ? '500px' : '90%';
            },
            height() {
                return this.windowWidth > 550 ? '600' : '90%';
            }
        },

        methods: {
            ...mapActions('shoppingCart', [
                'productInquiryRequest'
            ]),

            continueWithOrder() {
                this.$router.push({path: '/review-cart'});
            },

            validateEmail(email) {
                return email.match(
                    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                );
            },

            hideModal() {
                if(this.homePage){
                    this.confirmation = false;
                    this.message = "";
                }
                this.$emit('hide-modal')
            },

            onResize() {
                this.windowWidth = window.innerWidth;
            },

            keyUpHandler(e, input) {
                this[`${input}`] = DOMPurify.sanitize(e.target.value);
            },

            async productInquiryRequestHandler() {
                if (this.message !== '' && this.fullName !== '' && this.email !== '') {
                    if (!this.validateEmail(this.email)) {
                        this.error = "Please provide a valid email."
                    } else {
                        let response = await this.productInquiryRequest({ product: this.activeProductInfo ? this.activeProductInfo.name : this.productName, message: this.message, name: this.fullName, email: this.email });
                        if (response.data === "Success" && response.status === 200) {
                            this.confirmation = true;
                            this.error = '';
                            analyticsTrack('Product Inquiry Submitted', {
                                'product' : this.activeProductInfo ? this.activeProductInfo.key : this.productKey,
                            });
                        } else {
                            this.error = "Sorry, we had an error trying to process your request. Please reach out to your sales rep via email."
                        }
                    }
                } else {
                    this.error = "Please complete all fields before submitting."
                }
            }
        },

        mounted() {
            this.resize()
        },

        beforeDestroy() {
            window.removeEventListener('resize', this.onResize);
        }

    }
</script>

<style scoped>
    .inquire-wrapper {
        width: 100%;
        overflow-x: hidden;
    }

    .inquire-wrapper hr {
        width: 150%;
        margin-left: -30%;
    }

    .inputs-wrapper {
        padding: 20px;
        padding-bottom: 0px;
        padding-right: 10px;
        width: 100%;
    }

    .inputs-wrapper input {
        padding: 5px 10px;
    }

    .confirmation {
        padding: 30px;
        padding-bottom: 0px;
        padding-right: 10px;
        padding-top: 10px;
        width: 100%;
    }

    .confirmation p {
        font-weight: 400;
        font-size: 16px;
        line-height: 140%;
        color: #00263E;
    }

    .input-wrapper {
        margin-bottom: 20px;
        font-size: 16px;
    }

    .input-wrapper label {
        font-size: 16px;
        font-weight: 500;
    }

    .input-wrapper textarea {
        width: 100%;
        border: 1px solid #B2BFC7;
        border-radius: 4px;
        height: 100px;
        padding: .5rem;
    }

    .inquire-wrapper ::v-deep .rounded-full { 
        border-radius: 30px;
        padding: 5px 30px;
        max-width: 130px !important;
    }

    .modal-wrapper ::v-deep .close {
        width: 18px !important;
        height: 18px !important;
        top: 3px;
        left: 90%;
    }

    @media (max-width: 736px) {
        .modal-wrapper ::v-deep .cover {
            top: 75px !important;
        }
    }

    .modal-wrapper ::v-deep .close:before {
        height: 18px !important;
    }

    .modal-wrapper ::v-deep .close:after {
        height: 18px !important;
    }

    #modal-title {
        font-size: 24px;
        padding: 3px 30px;
        padding-bottom: 10px;
        text-align: left;
    }
</style>
